import { TextField } from '@mui/material';
import { Col, Row } from 'antd';
import { useEffect, useState } from 'react';
import { ConversionFormDetails } from '../conversionType';
import { DataIndexItem } from '../../../../types/interfaces';

interface ConversionDetailsProps {
    selectedConversionDetails: ConversionFormDetails;
    setSelectedConversionDetails: React.Dispatch<React.SetStateAction<ConversionFormDetails>>;
    data : DataIndexItem;
}

const GeometryMenuDetails: React.FC<ConversionDetailsProps> = ({ selectedConversionDetails, setSelectedConversionDetails, data }) => {
    const [isChecked1, setIsChecked1] = useState(selectedConversionDetails.simplify);
    const [isChecked2, setIsChecked2] = useState(selectedConversionDetails.noise_removal);

    // useEffect(() => {
    //     setSelectedConversionDetails(
    //         {
    //             ...selectedConversionDetails,
    //             translate : [
    //                 data.params?.translate?.[0] || 0,
    //                 data.params?.translate?.[1] || 0,
    //                 data.params?.translate?.[2] || 0
    //             ]
    //         }
    //     )
    //     setIsChecked1(data.params?.simplify || false);
    //     setIsChecked2(data.params?.noise_removal || false);
    // },[])

    const handleToggleChange1 = () => {
        const newValue = !isChecked1;
        setIsChecked1(newValue);
        setSelectedConversionDetails(prevState => ({
            ...prevState,
            simplify: newValue
        }));
    };

    const handleToggleChange2 = () => {
        const newValue = !isChecked2;
        setIsChecked2(newValue);
        setSelectedConversionDetails(prevState => ({
            ...prevState,
            noise_removal: newValue
        }));
    };

    const handleTranslateChange = (index: number, value: string) => {
        // Regular expression to allow negative and floating-point numbers
        const regex = /^-?\d*\.?\d*$/;
        if (!regex.test(value)) {
            return;
        }
        setSelectedConversionDetails(prevState => {
            const newTranslate = [...prevState.translate];
            newTranslate[index] = value;
            return {
                ...prevState,
                translate: newTranslate as [string, string, string] // Type assertion
            };
        });
    };

    const locked = data.locked
    const classNameString = locked ? 'cursor_drop' : ''
    return (
        <>
            <Row gutter={[16, 16]} className='panel_row'>
                <Col span={12}>
                    <TextField
                        label="Translate X"
                        value={selectedConversionDetails.translate[0] || 0}
                        onChange={(e) => handleTranslateChange(0, e.target.value)}
                        InputLabelProps={{ shrink: true }}
                        fullWidth
                        disabled={locked}
                        className={classNameString}
                    />
                </Col>
                <Col span={12}>
                    <TextField
                        label="Translate Y"
                        value={selectedConversionDetails.translate[1] || 0}
                        onChange={(e) => handleTranslateChange(1, e.target.value)}
                        InputLabelProps={{ shrink: true }}
                        fullWidth
                        disabled={locked}
                        className={classNameString}
                    />
                </Col>
            </Row>
            <Row gutter={[16, 16]} className='panel_row'>
                <Col span={12}>
                    <TextField
                        label="Translate Z"
                        value={selectedConversionDetails.translate[2] || 0}
                        onChange={(e) => handleTranslateChange(2, e.target.value)}
                        InputLabelProps={{ shrink: true }}
                        fullWidth
                        disabled={locked}
                        className={classNameString}
                    />
                </Col>
                <Col span={12}>

                </Col>
            </Row>
            <Row gutter={[16, 16]} className='panel_row switch_container'>
                <Col span={12}>
                    <label>Simplify</label>
                </Col>
                <Col span={12}>
                    <div className="toggle-wrapper">
                        <input id="switch1"
                            className="toggle"
                            type="checkbox"
                            checked={isChecked1}
                            onChange={handleToggleChange1} />
                        <label htmlFor="switch1" className="toggle--label"></label>
                        <div className="foux-toggle"></div>
                    </div>
                </Col>

            </Row>
            <Row gutter={[16, 16]} className='panel_row switch_container'>
                <Col span={12}>
                    <label>Noise Removal</label>
                </Col>
                <Col span={12}>
                    <div className="toggle-wrapper">
                        <input
                            id="switch2"
                            className="toggle"
                            type="checkbox"
                            checked={isChecked2}
                            onChange={handleToggleChange2}
                        />
                        <label htmlFor="switch2" className="toggle--label"></label>
                        <div className="foux-toggle"></div>
                    </div>
                </Col>
            </Row>
        </>
    );
}

export default GeometryMenuDetails;
